import { NgModule } from '@angular/core';
import { FocusOnShowDirective } from './focus';

@NgModule({ declarations: [FocusOnShowDirective], exports: [FocusOnShowDirective] })
export class FocusModule {}
